<script>
	// {
	// 	path: '/qitamanage/classmange',
	// 	title: '班级管理'
	// }
	
	
	const sidebarMenu = [{
			path: '/home',
			icon: 'el-icon-s-shop',
			title: '首页'
		},
		{
			path: '/studenthome',
			icon: 'el-icon-s-home',
			title: '我的首页'
		},
		{
			path: '/usercenter',
			icon: 'el-icon-s-custom',
			title: '个人中心',
			children: [{
					path: '/usercenter/usermessage',
					title: '个人信息'
				},
				{
					path: '/usercenter/mypromise',
					title: '我要预约'
				},
				{
					path: '/usercenter/myuserpromise',
					title: '我的预约'
				},
				{
					path: '/usercenter/myrealtest',
					title: '我的实训'
				}
			]
		},
		{
			path: '/allmanage',
			icon: 'fas fa-desktop',
			title: '实训设备管理',
			children: [{
					path: '/allmanage/trainingmange',
					title: '实训室管理'
				},
				{
					path: '/allmanage/trainingmangesb',
					title: '实训设备管理'
				},
				{
					path: '/allmanage/addmanges',
					title: '新增实训室'
				},
				{
					path: '/allmanage/addmangesb',
					title: '新增实训设备'
				},
				{
					path: '/allmanage/sourcemange',
					title: '设备电源管理'
				},
				{
					path: '/allmanage/addsourcemange',
					title: '增加设备电源'
				},
				{
					path: '/allmanage/stiticenotes',
					title: '操作记录'
				}
			]
		},
		{
			path: '/qitamanage',
			icon: 'fas fa-bandage',
			title: '其他管理',
			children: [{
					path: '/Usermanage/manage',
					title: '用户管理'
				},
				{
					path: '/Usermanage/appenduser',
					title: '新增用户'
				}, {
					path: '/qitamanage/shoolmanage',
					title: '院校管理'
				}, {
					path: '/qitamanage/menumange',
					title: '菜单管理'
				}, {
					path: '/qitamanage/usermange',
					title: '角色管理'
				},
				
				// {
				// 	path: '/qitamanage/clubmanage',
				// 	title: '部门管理'
				// },
				
				{
					path: '/qitamanage/specialtymange',
					title: '专业管理'
				},
				{
					path: '/authoritymange/authority',
					title: '权限管理'
				},
				{
					path: '/qitamanage/classmange',
					title: '班级管理'
				}

			]
		}, 	{
			path: '/information',
			icon: 'fa fa-earth-asia',
			title: '数据分析管理',
			children: [{
				path: '/information/orderselete',
				title: '预约/实训记录查询'
			}, {
				path: '/information/statistics',
				title: '数据统计分析'
			}, {
				path: '/information/logmange',
				title: '日志管理'
			},{
				path: '/information/tickling',
				title: '用户反馈'
			},{
				path: '/information/systemsrrtting',
				title: '系统设置'
			}]
		}
	]


	export default sidebarMenu;
</script>
